import classNames from 'classnames';
import React from 'react';

import Cell from '@commons/Table/Cell';

import { isAddingSelectedClassEnabled } from '@services/featureFlags';

import './anchor.global.scss';

interface AnchorProps {
  caption?: string;
  containerStyles?: string;
  isForcedShown?: boolean;
  isJustified?: boolean;
  isNaOption?: boolean;
  isOnFirstRow?: boolean;
  isSelected?: boolean;
}

function Anchor(props: AnchorProps) {
  const {
    caption,
    containerStyles,
    isForcedShown,
    isJustified,
    isNaOption,
    isOnFirstRow,
    isSelected,
    questionId,
    id
  } = props;

  const anchorStyles = classNames('anchor', 'anchor_customStyles', containerStyles, {
    anchor_isForcedShown: isForcedShown,
    anchor_isJustified: isJustified,
    anchor_isNaOption: isNaOption,
    anchor_isOnFirstRow: isOnFirstRow,
    anchor_isSelected: isAddingSelectedClassEnabled() && isSelected
  });
  const spanId = isOnFirstRow ? { id: `anchor_${questionId}_${isNaOption ? 'na' : id}` } : '';

  return (
    <Cell ariaHidden containerStyles={anchorStyles}>
      <span {...spanId} dangerouslySetInnerHTML={{ __html: caption }} />
    </Cell>
  );
}

export default Anchor;
